import PersonNoteList from './PersonNoteList';

export default PersonNoteList;
